import React from 'react';
import { QueryKey } from 'react-query';

import { I18nText } from '../../../../../types';
import { UniversalFilterView } from '../../UniversalFilter.types';
import {
  UniversalFilterCompanyStatusValue,
  UniversalFilterCompanyStatusModes,
  UniversalFilterCompanyStatusOnChange
} from './UniversalFilterCompanyStatus.types';

import { useUniversalFilterCompanyStatus } from './hooks/useUniversalFilterCompanyStatus';

import { TeamClientStatusesMultiSelect } from '../../../../../main/teams/helpers/TeamClientStatusesMultiSelect';

import { UniversalFilterTemplate } from '../../helpers/UniversalFilterTemplate';

interface UniversalFilterCompanyStatusProps {
  filterView?: UniversalFilterView;
  filterStateCacheKey: QueryKey;
  filterValue?: UniversalFilterCompanyStatusValue;
  i18nName: I18nText;
  autoFocus?: boolean;
  onChange: UniversalFilterCompanyStatusOnChange;
}

function UniversalFilterCompanyStatus({
  filterView,
  filterStateCacheKey,
  filterValue,
  i18nName,
  autoFocus,
  onChange
}: UniversalFilterCompanyStatusProps) {
  const { modeOptions, filterState, handleModeChange, handleStatusesChange } =
    useUniversalFilterCompanyStatus({
      filterStateCacheKey,
      filterValue,
      onChange
    });

  return (
    <UniversalFilterTemplate<UniversalFilterCompanyStatusModes>
      filterView={filterView}
      i18nName={i18nName}
      selectedMode={filterState.mode}
      modeOptions={modeOptions}
      onModeChange={handleModeChange}
    >
      <TeamClientStatusesMultiSelect
        key={filterState.mode}
        value={filterState.statuses || []}
        autoFocus={autoFocus}
        onChange={handleStatusesChange}
      />
    </UniversalFilterTemplate>
  );
}

export default UniversalFilterCompanyStatus;
